import styled from "styled-components";
import { Paper, Button } from "@mui/material";

export const StatusContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const StatusRow = styled(Paper)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  width: 100%;
  max-width: 800px;
  margin-bottom: 20px;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

export const BikeDetails = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

export const BikeImage = styled.img`
  width: 200px;
  height: 200px;
  margin-right: 20px;

  @media (max-width: 600px) {
    margin-right: 0;
    margin-bottom: 10px;
    width: 150px;
    height: 150px;
  }
`;

export const StatusBox = styled.div`
  padding: 10px 20px;
  background-color: blue;
  color: white;
  border-radius: 5px;
  margin-bottom: 10px;
`;

export const StyledButton = styled(Button)`
  margin: 10px;

  @media (max-width: 600px) {
    margin: 5px;
    width: 100%;
  }
`;
